import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

const CookieBanner = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    // Added max-h-screen and overflow-y-auto to prevent the banner from blocking the whole mobile view
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 pb-6 bg-gray-900 text-white shadow-2xl border-t border-gray-700 animate-slide-up max-h-[50vh] overflow-y-auto">
      <div className="max-w-7xl mx-auto relative pr-8 md:pr-0">
        
        {/* Close Button - Moved to absolute position for mobile accessibility */}
        <button 
          onClick={() => setIsVisible(false)} 
          className="absolute -top-2 -right-2 md:static text-gray-400 hover:text-white p-2"
          aria-label="Close"
        >
          <XMarkIcon className="h-6 w-6" />
        </button>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          
          {/* Content */}
          <div className="flex-1 text-sm text-gray-300 leading-relaxed">
            <p>
              <strong className="text-white block mb-1 md:inline md:mb-0">
                {t('common.we-use')}
              </strong> 
              {" "} {t('common.cookie-text')}
              {" "}
              <Link to="/privacy" className="underline text-blue-400 hover:text-blue-300 whitespace-nowrap">
                {t('common.read-more')}
              </Link>.
            </p>
          </div>

          {/* Action Button */}
          <div className="w-full md:w-auto shrink-0">
            <button 
              onClick={handleAccept}
              className="w-full md:w-auto bg-[#1d5cab] hover:bg-[#2372bd] text-white px-8 py-3 md:py-2 rounded-lg text-sm font-bold transition shadow-lg"
            >
              {t('common.cookie-banner.acknowledge')}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
